import { BaseBlock, ParsedBlock } from '../chat-data/types'

export type BlockOrCompositeBlock =
  | ParsedBlock
  | ({ type: 'SystemUserResponded' } & BaseBlock)
  | ({
      type: 'SystemChatTransferred'
    } & BaseBlock)

/**
 * Adds FE only events based on BE event sequences
 *
 * FE: SystemUserResponded
 *
 * - SystemMessage (SystemConversationAssigned)
 * - LiveMessage
 *
 * Or
 *
 * - SystemMessage (SystemConversationReassigned)
 * - LiveMessage
 *
 * FE: SystemChatTransferred
 *
 * - LiveMessage
 * - SystemMessage (SystemConversationReassigned)
 */
export const getBlocksWithCompositeBlocks = (
  blocks: ParsedBlock[],
  guestId: string
): BlockOrCompositeBlock[] => {
  const result: BlockOrCompositeBlock[] = []
  let isPendingLiveMessage = false
  let isPendingConversationReassigned = false
  for (const block of blocks) {
    if (
      block.type === 'SystemMessage' &&
      (block.payload.type === 'SystemConversationAssigned' ||
        block.payload.type === 'SystemConversationReassigned')
    ) {
      isPendingLiveMessage = true
    }
    if (block.type === 'LiveMessage' && block.author !== `${guestId}_guest`) {
      isPendingConversationReassigned = true
      if (isPendingLiveMessage) {
        isPendingLiveMessage = false
        result.push({
          ...block,
          type: 'SystemUserResponded',
        })
      }
    }
    if (
      isPendingConversationReassigned &&
      block.type === 'SystemMessage' &&
      block.payload.type === 'SystemConversationReassigned'
    ) {
      isPendingConversationReassigned = false
      result.push({
        ...block,
        type: 'SystemChatTransferred',
      })
    }
    if (block.type !== 'SystemMessage' || block.payload.type === 'SystemConversationAssigned') {
      result.push(block)
    }
  }
  return result
}
